import React, { useEffect, useMemo, useState } from "react";
import {
  ArrowLeft,
  // Search,
  // Filter,
  // Package,
  // Truck,
  // CheckCircle,
  // Clock,
  // AlertCircle,
  // Calendar,
  // DollarSign,
  // User,
} from "lucide-react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../Context/AuthContext";
import { toast } from "sonner";

const OrderHistory = () => {
  const navigate = useNavigate();
  const { sellerId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { getToken } = useAuth();

  function timeAgo(dateString) {
    const now = new Date();
    const date = new Date(dateString);
    const diff = Math.floor((now - date) / (1000 * 60 * 60 * 24));
    if (diff === 0) return "Today";
    if (diff === 1) return "1 day ago";
    return `${diff} days ago`;
  }
  const [searchTerm] = useState(
    searchParams.get("search") || ""
  );
  const [selectedStatus] = useState(
    searchParams.get("status") || "all"
  );
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    lastPage: 1,
    perPage: 20,
    total: 0,
  });

  console.log(error);
  

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        setError(null);
        const token = getToken();
        if (!token) {
          setError("No authentication token found");
          setLoading(false);
          return;
        }

        const params = new URLSearchParams();
        const page = parseInt(searchParams.get("page") || "1", 10);
        if (page > 1) params.append("page", String(page));
        const search = searchParams.get("search");
        if (search) params.append("search", search);
        const status = searchParams.get("status");
        if (status && status !== "all") params.append("status", status);

        const url = `https://apisellhub.com/api//admin/sellers-order/${sellerId}?${params.toString()}`;
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.data?.status) {
          setOrders(response.data.data || []);
          setPagination({
            currentPage: response.data.page_count.current_page,
            lastPage: response.data.page_count.last_page,
            perPage: response.data.page_count.per_page,
            total: response.data.page_count.total,
          });
        } else {
          setError("Failed to load orders");
        }
      } catch (err) {
        if (err.response?.status === 401) {
          navigate("/center/login", { replace: true });
          sessionStorage.removeItem("Market-token");
          toast.error('Token Expired. Please login again.');
          // setError('Authentication failed. Please login again.');
        } else {
          // setError('Failed to load dashboard data');
        }
        console.error("Orders API error:", err);
        setError("Failed to load orders");
      } finally {
        setLoading(false);
      }
    };

    if (sellerId) {
      fetchOrders();
    }
  }, [sellerId, searchParams, getToken,navigate]);

  const filteredOrders = useMemo(() => {
    const localSearch = searchTerm.trim().toLowerCase();
    return orders.filter((order) => {
      const idStr = String(order.id || "").toLowerCase();
      const customerStr = String(
        order.customer || order.customer_name || ""
      ).toLowerCase();
      const productStr = String(
        order.product || order.product_name || ""
      ).toLowerCase();
      const sellerStr = String(
        order.seller || order.seller_name || ""
      ).toLowerCase();
      const statusStr = String(order.status || "").toLowerCase();

      const matchesSearch =
        !localSearch ||
        idStr.includes(localSearch) ||
        customerStr.includes(localSearch) ||
        productStr.includes(localSearch) ||
        sellerStr.includes(localSearch);

      const matchesStatus =
        selectedStatus === "all" || statusStr === selectedStatus.toLowerCase();
      return matchesSearch && matchesStatus;
    });
  }, [orders, searchTerm, selectedStatus]);



  // const handleSearchApply = () => {
  //   const next = new URLSearchParams(searchParams);
  //   if (searchTerm.trim()) next.set("search", searchTerm.trim());
  //   else next.delete("search");
  //   if (selectedStatus && selectedStatus !== "all")
  //     next.set("status", selectedStatus);
  //   else next.delete("status");
  //   next.set("page", "1");
  //   setSearchParams(next);
  // };

  const handlePageChange = (page) => {
    const pageNum = Math.max(1, Math.min(page, pagination.lastPage));
    const next = new URLSearchParams(searchParams);
    next.set("page", String(pageNum));
    setSearchParams(next);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => navigate("/center/seller")}
            className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
            <span>Back to Seller</span>
          </button>
          {/* <div>
            <h2 className="text-2xl font-bold text-white">Order History</h2>
            <p className="text-gray-400">View and manage all orders from sellers</p>
          </div> */}
        </div>
      </div>
      <div>
        <h2 className="text-2xl font-bold text-white">Seller Orders</h2>
        {/* <p className="text-gray-400">View and manage all orders from sellers</p> */}
      </div>

      {/* Orders Table */}
      <div className="bg-gray-800 rounded-lg border border-gray-700 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-700">
            <thead className="bg-gray-700">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  UUID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider whitespace-nowrap">
                  PRODUCT NAME
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider whitespace-nowrap">
                  CUSTOMER NAME
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider whitespace-nowrap">
                  CUSTOMER EMAIL
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider whitespace-nowrap">
                  PAYMENT STATUS
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider whitespace-nowrap">
                  ORDER NOTE
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  SUBTOTAL
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  DISCOUNT
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  TOTAL
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider whitespace-nowrap">
                  PYAMENT METHOD
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  DATE
                </th>
              </tr>
            </thead>
            <tbody className="bg-gray-800 divide-y divide-gray-700">
              {loading && (
                <tr>
                  <td
                    colSpan={9}
                    className="px-6 py-10 text-center text-gray-400"
                  >
                    Loading...
                  </td>
                </tr>
              )}
              {!loading && filteredOrders.length === 0 && (
                <tr>
                  <td
                    colSpan={9}
                    className="px-6 py-10 text-center text-gray-400"
                  >
                    No orders found
                  </td>
                </tr>
              )}
              {!loading &&
                filteredOrders.map((order) => (
                  <tr
                    key={order.id}
                    className="hover:bg-gray-700 transition-colors"
                  >
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-white">
                        {order.uuid}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div>
                        <div className="text-sm font-medium text-white">
                          {order.product_title || order.product_title || "-"}
                        </div>
                        {/* <div className="text-sm text-gray-400">{order.name || order.name || '-'}</div> */}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-white">
                        {order.name || order.name || "-"}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-300">
                        {order.email || order.email || "-"}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium">
                        {order.payment_status === 0 && (
                          <span className="px-3 py-1 border border-yellow-500 text-yellow-500 rounded-full text-xs font-semibold">
                            Pending
                          </span>
                        )}
                        {order.payment_status === 1 && (
                          <span className="px-3 py-1 border border-green-500 text-green-500 rounded-full text-xs font-semibold">
                            Paid
                          </span>
                        )}
                        {order.payment_status === 2 && (
                          <span className="px-3 py-1 border border-red-500 text-red-500 rounded-full text-xs font-semibold">
                            Expired
                          </span>
                        )}
                        {order.payment_status !== 0 &&
                          order.payment_status !== 1 &&
                          order.payment_status !== 2 && (
                            <span className="px-3 py-1 border border-gray-500 text-gray-500 rounded-full text-xs font-semibold">
                              N/A
                            </span>
                          )}
                      </div>
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-white">
                        {order.order_note || order.order_note || "N/A"}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-300">
                        {order.sub_total || order.sub_total || 0}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-300">
                        {order.discount || order.discount || "-"}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-300">
                        {order.total || order.total || "-"}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-300">
                        {order.payment_method || order.payment_method || "-"}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-300">
                        {timeAgo(order.created_at)}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      {pagination.total > 0 && (
        <div className="bg-gray-800 rounded-lg border border-gray-700 p-4">
          <div className="flex items-center justify-between">
            <div className="text-sm text-gray-400">
              Showing {(pagination.currentPage - 1) * pagination.perPage + 1} to{" "}
              {Math.min(
                pagination.currentPage * pagination.perPage,
                pagination.total
              )}{" "}
              of {pagination.total} results
            </div>
            <div className="flex items-center space-x-2">
              <button
                onClick={() => handlePageChange(pagination.currentPage - 1)}
                disabled={pagination.currentPage <= 1}
                className="px-3 py-1 text-sm text-gray-400 hover:text-white disabled:opacity-50"
              >
                Previous
              </button>
              <span className="px-3 py-1 text-sm text-white bg-purple-600 rounded">
                {pagination.currentPage}
              </span>
              <button
                onClick={() => handlePageChange(pagination.currentPage + 1)}
                disabled={pagination.currentPage >= pagination.lastPage}
                className="px-3 py-1 text-sm text-gray-400 hover:text-white disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderHistory;
